// src/components/AugustTexture.js
// Shared background texture for the august screens: aged corner shading, coffee
// rings, handwritten wallpaper, and static ink splats. Each screen supplies its own
// wallpaper lines and ring/splat position config; only the aged-shading formula is
// switchable via `variant` since Splash predates the corner/vmin fix Today/Journey got.
import React from 'react'
import './AugustTexture.css'

export default function AugustTexture({ wallpaperLines, rings = [], splats = [], variant = 'corner', lineCount = 24 }) {
  const wallpaper = Array.from({ length: lineCount }, (_, i) => wallpaperLines[i % wallpaperLines.length])

  return (
    <>
      <div className={`aug-texture-aged aug-texture-aged--${variant}`} />

      {rings.map((r, i) => <div key={i} className="aug-texture-ring" style={r} />)}

      <div className="aug-texture-lyrics">
        {wallpaper.map((line, i) => <p key={i}>{line}</p>)}
      </div>

      {splats.map((s, i) => <div key={i} className="aug-texture-splat" style={s} />)}
    </>
  )
}
